export const registerPublicPlugins = () => {};
